module.exports = __webpack_public_path__ + "img/technology-people-gelb-neu.968fc0b5.svg";